import request from './axios';

/**
 * 获取组织架构树
 * @returns {Promise<Object>} 返回组织架构树
 */
export function getOrganizationTree() {
  return request({
    url: '/webapi/organization/tree',
    method: 'get'
  });
} 